import React from "react";
import { ListGroup, Container } from "react-bootstrap";
import { MdOutlineListAlt } from "react-icons/md";
import CustomAvatar from "./ui/CustomAvatar";
import { Header } from "../pages/Home";

const ActivityLogUI = ({ title, activities, user, loading, error }) => {
  if (loading) {
    return <p>Loading {title.toLowerCase()}...</p>;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  return (
    <Container
      className="mt-5 mb-5 pb-3 rounded-4"
      style={{
        padding: 0,
        border: "1px solid #f0efef",
        background: "transparent",
      }}
    >
      <Header
        title={title}
        icon={<MdOutlineListAlt size={35}  />}
        showButton={false}
      />

      {activities?.length > 0 ? (
        <ListGroup
          className="mt-3 mx-3"
          style={{
            borderRadius: "12px",
            border: "1px solid #f0efef",
            padding: 0,
            background: "#fafafa",
          }}
        >
          {[...activities]
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
            .map((activity) => (
            <ListGroup.Item
              key={activity.content_id || activity.timestamp}
              className="d-flex flex-column flex-sm-row justify-content-between gap-0 px-5 py-4 mb-2"
              style={{
                border: "none",
                position: "relative",
                paddingLeft: "15px",
                paddingRight: "15px",
                background: "transparent",
              }}
            >
              <div className="col-12 col-sm-12 d-flex align-items-center gap-3">
                <CustomAvatar user={user ||activity?.user} size="35px" fontSize="14px"  />
                <span
                  style={{
                    width: "100%",
                    fontSize: "15px",
                    whiteSpace: "wrap",
                    overflow: "hidden",
                  }}
                >
                  <strong>{user?.first_name || activity?.user?.first_name} {user?.last_name || activity?.user?.last_name}</strong>
                  <span className="px-2">{activity.content}</span>
                  <span style={{ fontSize: "13px", color: "#7e7e7e", fontWeight: 500 }}>
                    {`(${new Date(activity.timestamp).toLocaleString()})`}
                  </span>
                </span>
              </div>

              <div
                style={{
                  position: "absolute",
                  padding: "2px",
                  bottom: 0,
                  left: "15px",
                  right: "15px",
                  borderBottom: "1px solid  #d4cfcf",
                }}
              />
            </ListGroup.Item>
          ))}
        </ListGroup>
      ) : (
        <p className="d-flex pt-3 align-items-center justify-content-center">No activities available.</p>
      )}
    </Container>
  );
};

export default ActivityLogUI;
